import { PartialRecursive } from '@bridebook/models/source/abstract/_';
import { IBucket } from '@bridebook/models/source/models/Countries/Buckets.types';

const result: PartialRecursive<IBucket['settings']> = {
  searchFilters: {
    venue: {
      venueType: [
        'countryHouseManorHouse',
        'barn',
        'gardenOutdoor',
        'statelyHome',
        'castle',
        'hotel',
        'cityHotelCityVenue',
        'warehouseFactory',
        'museumAttraction',
        'uniqueVenueType',
        'pubRestaurant',
        'golfCourse',
        'cruiseBoatYacht',
        'sportingVenueStadium',
        'conferenceCentre',
        'placeOfWorship',
        'townHallRegistryOffice',
        'otherVenueType',
        'winery',
      ],
    },
  },
};

export default result;
